<template>
  <div class="reports">
    <ReportWinloseComponent
      :ref-key-text="refKeyText"
      :title="title"
      :url-path="urlPath"
      :route-name="routeName"
      :is-simple="true"
      :is-search-username="false"
    />
  </div>
</template>

<script>
import ReportWinloseComponent from '@/components/ReportWinloseComponent.vue'

export default {
  components: {
    ReportWinloseComponent,
  },
  data() {
    return {
      refKeyText: 'Match',
      title: 'W/L Match (Simple)',
      urlPath: '/reports/v2/match_winlose_simple',
      routeName: 'reports-match-winlose-simple',
    }
  },
}
</script>

<style>

</style>
